import { friendList, bi, customDialogSceneID } from './gb'
import { userInfo, roleList, Role, isRoleBind } from './role'
import Login from './login'
import fullPage from './fullpage'
import { setTip } from './gb'

const Friend = {
  UI_friendReset: () => {
    $('[data-friend-sum]').text(0)
    $('[data-friend-desc]').text(friendList[0])
  },
  UI_friendInit: () => {
    $('[data-friend-sum]').text(userInfo.sonsum_1_8_0)

    let sonLevel = 0,
      level = 0

    if (userInfo.sonsum_1_8_0 <= 1) {
      $('[data-friend-desc]').text(friendList[0])
    } else if (userInfo.sonsum_1_8_0 > 1 && userInfo.sonsum_1_8_0 <= 5) {
      $('[data-friend-desc]').text(friendList[1])
    } else {
      $('[data-friend-desc]').text(friendList[2])
    }

    if (userInfo.sonsum_1_8_0 >= 1 && userInfo.sonsum_1_8_0 < 3) {
      sonLevel = 1
    } else if (userInfo.sonsum_1_8_0 >= 3 && userInfo.sonsum_1_8_0 < 5) {
      sonLevel = 2
    } else if (userInfo.sonsum_1_8_0 >= 5 && userInfo.sonsum_1_8_0 < 10) {
      sonLevel = 3
    } else if (userInfo.sonsum_1_8_0 >= 10) {
      sonLevel = 4
    }

    if (userInfo.level >= 19 && userInfo.level < 29) {
      level = 1
    } else if (userInfo.level >= 29 && userInfo.level < 49) {
      level = 2
    } else if (userInfo.level >= 49 && userInfo.level < 59) {
      level = 3
    } else if (userInfo.level >= 59) {
      level = 4
    }
    for (let i = 0; i < sonLevel; i++) {
      $('[data-btn-lb-i' + (i + 1) + '-1]')
        .removeClass('predisabled')
        .closest('.item')
        .removeClass('predisabled')
    }
    for (let i = 0; i < level; i++) {
      $('[data-btn-lb-l' + (i + 1) + ']')
        .removeClass('predisabled')
        .closest('.item')
        .removeClass('predisabled')
    }

    const myInviteUrl =
      location.href.split('?')[0].split('#')[0] +
      '?code=' +
      userInfo.invite_code
    $('[data-invite-url]').val(myInviteUrl)
    const clipboard = new ClipboardJS('[data-btn-clip]')
    clipboard.on('success', function() {
      setTip('复制成功')
    })
    clipboard.on('error', function() {
      if (/ucbrowser/gi.test(navigator.userAgent)) {
        setTip('复制成功')
      } else {
        setTip('复制失败')
      }
    })
    pandora.use(['clipboard', 'qrcode'], function(Clipboard, Qrcode) {
      new Qrcode({
        element: '[data-code-friend]',
        text: myInviteUrl,
        size: 120,
        image: '//cdn.tlsy.cy.com/a/act/2019/0410/img/code-logo.png'
      })
    })
  }
}

$('[data-btn-firend]').click(async () => {
  await Login.checkLogin()
  if (roleList.length > 0 && isRoleBind) {
    $(`[data-dialog-friend] [data-btn-target="${customDialogSceneID}"]`)
      .hide()
      .siblings('.note')
      .show()
    $('[data-dialog-friend]').show()
  } else {
    Role.state_roleUnbind()
  }
  bi('按钮-立即邀请好友')
  fullPage.lockScroll()
})

export default Friend
